<template><div><h1 id="umsatze" tabindex="-1"><a class="header-anchor" href="#umsatze"><span>Umsätze</span></a></h1>
<p>Umsätze — Umsätze von Adressen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Anzeige der kumulierten Umsätze zur Adresse. Es wird nach Spenden- und Kaufumsätzen unterschieden (siehe Beispiel).</p>
<p>Pfad: <code v-pre>Personen → Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jahr</dt>
<dd>Umsatzjahr</dd>
<dt>Typ</dt>
<dd>Umsatztyp gemäss Tabelle <a class="link" href="ft.refdata.umsatzcode.html" title="Umsatztypen">Umsatzcode</a></dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung des Umsatzcodes</dd>
<dt>Adressumsatz</dt>
<dd>Adressumsatz kumuliert für das aufgeführte Jahr in Franken, ohne die Umsätze anderer Haushaltsmitglieder.</dd>
<dt>Haushaltsumsatz</dt>
<dd>Haushaltsumsatz kumuliert für das gezeigte Jahr in Franken. Darin enthalten ist sowohl der Adressumsatz der gewählten Adresse, als auch der Umsatz aller anderen Haushaltsmitglieder im aufgeführten Jahr.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


